<template lang="pug">
.project-report(v-if="loaded")
	h4.report-tab Project Information
	include ../project-report/information.pug

	h4.report-tab Contacts
	br
	//- p {{ project.sgnrIsDcsnMkr }}
	contacts-block(:contacts="project.contacts", :isSecondToo="project.sgnrIsDcsnMkr")

	h4.report-tab Preferred Compliance Actions
	include ../project-report/compliance-actions.pug

	floors-roofs(v-if="canShow('floorsRoofs')", :project="project", :control="control", :readonly="true", :findControlTextByKey="findControlTextByKey")
	floors-roofs-addition(v-if="canShow('floorsRoofsAdd')", :project="project", :control="control", :readonly="true", :findControlTextByKey="findControlTextByKey")

	mechanical-systems(v-if="canShow('mechSys')", :project="project", :control="control", :readonly="true", :findControlTextByKey="findControlTextByKey")
	mechanical-systems-addition(v-if="canShow('mechSysAdd')", :project="project", :control="control", :readonly="true", :findControlTextByKey="findControlTextByKey")
	mechanical-systems-remodel(v-if="canShow('mechSysRem')", :project="project", :control="control", :readonly="true", :findControlTextByKey="findControlTextByKey")

	walls(v-if="canShow('walls')", :project="project", :control="control", :readonly="true", :findControlTextByKey="findControlTextByKey")
	walls-addition(v-if="canShow('wallsAdd')", :project="project", :control="control", :readonly="true", :findControlTextByKey="findControlTextByKey")

	glazing-in-existing(:project="project", :control="control", v-if='!project.isNewHome && project.takeoff != projType.remodel', :readonly="true", :findControlTextByKey="findControlTextByKey")

	glazing(:project="project", :control="control", :readonly="true", v-if="project.takeoff != projType.remodel", :findControlTextByKey="findControlTextByKey")
</template>
<script>
import Vue from 'vue'
import _ from 'lodash'
import MechanicalSystems from 'App/take-off-tool/tabs-components/mechanical-systems.vue'
import MechanicalSystemsAddition from 'App/take-off-tool/tabs-components/mechanical-systems-addition.vue'
import MechanicalSystemsRemodel from 'App/take-off-tool/tabs-components/mechanical-systems-remodel.vue'
import Compliance from 'App/take-off-tool/tabs-components/compliance.vue'
import FloorsRoofs from 'App/take-off-tool/tabs-components/floors-roofs.vue'
import FloorsRoofsAddition from 'App/take-off-tool/tabs-components/floors-roofs-addition.vue'
import Walls from 'App/take-off-tool/tabs-components/walls-tab.vue'
import WallsAddition from 'App/take-off-tool/tabs-components/walls-tab-addition.vue'
import Glazing from 'App/take-off-tool/tabs-components/glazing.vue'
import GlazingInExisting from 'App/take-off-tool/tabs-components/glazing-in-existing.vue'

export default {
	name: 'project-preview',
	props: ['projId'],
	components: {
		FloorsRoofs,
		FloorsRoofsAddition,
		MechanicalSystems,
		MechanicalSystemsAddition,
		MechanicalSystemsRemodel,
		Walls,
		WallsAddition,
		Glazing,
		GlazingInExisting,
		Compliance
	},
	data () {
		return {
			project: {},
			control: {},
			loaded: false,
			projType: {}
		}
	},
	methods: {
		findControlTextByKey (control, value) {
			return Vue.e24.formService.findControlTextByKey(control, value, this.control)
		},
		canShow (screenName) {
			let canShow = false
			switch (this.project.takeoff) {
			case process.env.PROJTYPE.newBuilding:
			case process.env.PROJTYPE.detachedAdd:
				canShow = (_.indexOf(['floorsRoofs', 'mechSys', 'walls', 'glazing', 'compliance'], screenName) !== -1)
				break
			case process.env.PROJTYPE.ePlusAdd:
			case process.env.PROJTYPE.conversion:
				canShow = (_.indexOf(['floorsRoofsAdd', 'mechSysAdd', 'wallsAdd', 'glazing', 'glazingExist', 'compliance'], screenName) !== -1)
				break
			case process.env.PROJTYPE.remodel:
				canShow = (_.indexOf(['floorsRoofs', 'mechSysRem', 'wallsAdd', 'compliance'], screenName) !== -1)
				break
			}
			return canShow
		}
	},
	created () {
		this.projType = process.env.PROJTYPE
		let project
		console.log('this.projId', this.projId)
		Vue.e24.projectService.findOneById(this.projId).then((projectLoaded) => {
			project = projectLoaded
			return Vue.e24.formService.findControlByForm(['info', 'mech', 'walls', 'glazing_existing', 'glazing', 'floor_attic', 'prefs'])
		}).then((control) => {
			// Loading project
			this.project = project
			this.control = control
			this.loaded = true
		})
		// console.debug('control are ', JSON.stringify(this.control))
	}
}
</script>
<style lang="less">
// Needed since we are using this components inside admin panel also
@import '~Css/responsive';
@import '~Css/layouts/takeoff';
@import '~Css/layouts/audit';
</style>



// WEBPACK FOOTER //
// src/app/project/preview-component.vue